module.exports = __webpack_public_path__ + "static/img/banner.0caf6d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner.jpg
// module id = phMG
// module chunks = 1